import { render, staticRenderFns } from "./discussions.vue?vue&type=template&id=15f5e70e&scoped=true&"
import script from "./discussions.vue?vue&type=script&lang=js&"
export * from "./discussions.vue?vue&type=script&lang=js&"
import style0 from "./discussions.vue?vue&type=style&index=0&id=15f5e70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5e70e",
  null
  
)

export default component.exports